import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function NotFound() {
  return (
    <div>
      <SEO
        title="Page Not Found | 7th Vision"
        description="The page you were looking for could not be found. Return home, view solutions, or contact 7th Vision."
      />
      <section className="relative min-h-screen bg-stone-900 flex items-center overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-20"
          style={{
            backgroundImage:
              'url(https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg?auto=compress&cs=tinysrgb&w=1920)',
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-stone-900/60 via-stone-900/85 to-stone-900" />

        <div className="relative section-padding w-full py-32">
          <div className="max-w-3xl">
            <p className="section-label text-bronze-400 mb-6">404</p>
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-stone-100 leading-tight mb-6">
              This page could not be found.
            </h1>
            <p className="text-stone-400 text-lg font-light max-w-xl leading-relaxed mb-10">
              The link may be outdated, or the address may have been typed incorrectly.
              You can return home or keep moving through the main parts of the site.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Link to="/" className="btn-outline-light text-center">
                Back Home
              </Link>
              <a href="/#solutions" className="btn-outline-light text-center">
                View Solutions
              </a>
              <Link to="/contact" className="btn-outline-light text-center">
                Contact
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
